









import VueOptions from '@utils/VueOptions'

settings =
  name: "ShoppingCartDiscountCard"

  vue:
    props: ['lineItem', 'actions']

export default VueOptions.vue settings
